import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import axios from 'axios';
import { getSum } from '@/utils/utils';
import moment from 'moment';
import { drillDownAPI } from '@/providers/apis/drill-down/drill-down';
import { CompetencyModel } from '@/models/drill-down/competency';
import { PerformanceModel } from '@/models/drill-down/performance';
import { SubjectModel } from '@/models/drill-down/subject';
import { DrillDownModel } from '@/models/drill-down/drill-down';
import { numberFormat } from '@/helpers/number-format';
import DrilldownPerfPullup from '@/components/pull-up/drilldown-perf-pullup/drilldown-perf-pullup';
import { PerformanceData } from '@/models/groups/performance';
import { GroupsReport, ReportData } from '@/models/groups/report';
import { ClassCompetencyData, ReportPerformanceStatsModel } from '@/models/groups/class';
import { tickStep } from 'd3';

@Component({
  name: 'network-performance-card',
  components: {
    'material-icon': GoogleMaterialIcon,
    'drilldown-perf-pullup': DrilldownPerfPullup,
  },
})

export default class NetworkPerformanceCard extends Vue {


  private get averagePerformanceScore() {
    const avgPerf = (this.groupType === 'class' ?
      this.classCompetencyData && this.classCompetencyData.overallStats ?
        this.classCompetencyData.overallStats.overallAveragePerformance : 0 || 0 :
      this.performanceData && this.performanceData.overallStats ?
        this.performanceData.overallStats.averagePerformance : 0) || 0;
    return avgPerf > 0 ? avgPerf.toFixed(2) : 0;
  }

  private get totalCompletedCompetencies() {
    return this.groupType === 'class' ?
      this.classCompetencyData && this.classCompetencyData.overallStats ?
        this.classCompetencyData.overallStats.overallMasteredCompetencies : '' || 0 :
      this.competencyData && this.competencyData.overallStats ?
        this.competencyData.overallStats.overallMasteredCompetencies : '' || 0;
  }


  // ------------------------------------------------------------
  // Properties

  @Prop()
  private selectedDate?: string;

  @Prop()
  private performanceData!: PerformanceData;

  @Prop()
  private competencyData!: ReportData;

  @Prop()
  private classCompetencyData!: ClassCompetencyData;

  @Prop()
  private groupType!: string;

  @Prop()
  private groupId!: string;

  @Prop({ default: false })
  private isLoading!: boolean;

  @Prop()
  private isAtInitialLevel!: boolean;

  @Prop()
  private subjectList!: SubjectModel[];

  @Prop()
  private selectedSubject!: any;
  @Prop()
  private activeMonth!: string;
  @Prop()
  private activeYear!: string;

  private selectedLevel: DrillDownModel | any = null;

  private isShowPerfPullup: boolean = false;

  private activeSubject: SubjectModel | any = this.subjectList ? this.subjectList[0] : null;

  private defaultLevel: any = this.selectedLevel;

  @Prop({ default: false })
  private isRestrictClass!: boolean;

  @Prop()
  private competencyPerformance!: ReportPerformanceStatsModel;

  // ------------------------------------------------------------
  // Actions

  private onClosePerfPullup() {
    this.isShowPerfPullup = false;
  }

  private onSelectLevel(level: any, subject: any, data: any) {
    this.selectedLevel = level;
    this.$emit('onSelectLevel', level, subject, data);
  }

  private onSelectSubject(subject: any) {
    this.activeSubject = subject;
    this.$emit('onSelectLevel', this.selectedLevel, this.activeSubject, 'performance');
  }

  private onShowPerfPullup() {
    this.isShowPerfPullup = true;
    this.activeSubject = this.selectedSubject;
    this.selectedLevel = null;
    this.$emit('onSelectLevel', this.selectedLevel, this.activeSubject, 'performance');
  }

  private onGoUpward(subject: any, data: any, active: any) {
    this.selectedLevel = this.defaultLevel;
    this.$emit('onGoUpward', subject, data, active);
  }

  // ---------------------------------------------------------------
  // Hooks

  // ----------------------------------------------------------------
  // Methods


  private numberFormat(value: number) {
    return numberFormat(value);
  }


}
